<h2>Create search for new property</h2>
<shared-button-with-image
  headline="Residential"
  description="Get competitive rates and expert advice to finance your residential property purchase effortlessly."
  imagePath="/assets/images/dialog-house-residential.png"
  contentStyleClass="bg-gray-5 w-100"
  [isSelected]="
    stepFormGroup.value.type === ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_RESIDENTIAL
  "
  [showArrowIcon]="false"
  (click)="setValue(ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_RESIDENTIAL)" />
<shared-button-with-image
  headline="Buy to let"
  description="Access tailored buy-to-let mortgage options designed to maximize your rental returns."
  imagePath="/assets/images/dialog-house-buy-to-let.png"
  contentStyleClass="bg-gray-5  w-100"
  [isSelected]="
    stepFormGroup.value.type === ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_BUY_TO_LET
  "
  [showArrowIcon]="false"
  (click)="setValue(ENUM_PropertyInvestmentType.PROPERTY_INVESTMENT_TYPE_BUY_TO_LET)" />
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  [hideBackButton]="!isBackButtonVisible"
  [showSkipButton]="false"
  (forward)="emitNextClicked()"
  (back)="emitBackClicked()" />
